import { render } from "./MiPagination.vue?vue&type=template&id=6b4aa3fa&scoped=true"
import script from "./MiPagination.vue?vue&type=script&lang=js"
export * from "./MiPagination.vue?vue&type=script&lang=js"

import "./MiPagination.vue?vue&type=style&index=0&id=6b4aa3fa&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4aa3fa"]])

export default __exports__
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPagination,QBtn,QIcon});
